import { RouteNames } from "../../modules/router/constantes/routes.const";
import { QueryName } from "../../modules/router/constantes/queryName";

export const authRedirect = () => {
  const nextRoute = window.location.pathname;
  window.open(`${RouteNames.login}?${QueryName.nextRoute}=${nextRoute}`, "_self");
};

export const redirectToErrorPage404 = () => {
    window.open(`${RouteNames.errorPage404}`, "_self");
};

export const redirectToErrorPage500 = () => {
  window.open(`${RouteNames.errorPage500}`, "_self");
};
